import { solanaRpcEndpoints } from '@/constants/solana'
import {
  apiEndpoint,
  datasourceApiEndpoint,
  proxyApiEndpoint,
  splTokenApiEndpoint,
} from '@/environment'
import { updateAssistantPendingCount } from '@/features/historyAssistant/api/updateAssistantPendingCount'
import { acquireWriteOperation } from '@/features/portfolio/states/writeOperation'
import { getPortfolioFromLocalStorage } from '@/localStorage'
import type { RunToDatabase } from '@/types'
import { fiatCurrencies } from '@pkg/basic'
import { atom } from 'jotai'
import { analyzeAccountList } from '../usecases/analyzeAccountList'
import { updateIsRequiredCalculationAtom } from './calculate'

export const analyzeAccountListAtom = atom(
  undefined,
  async (
    _,
    set,
    parameters: {
      readFromDatabase: RunToDatabase
      writeToDatabase: RunToDatabase
      getToken: () => Promise<string | null>
      readonly targetAccountIdList: readonly number[] | undefined
      readonly skipPolkadotIndexFetch?: boolean
      readonly beforePolkadotAnalyze?: () => Promise<void>
      onError: (error: unknown) => void
    },
  ) => {
    const portfolio = getPortfolioFromLocalStorage()
    if (portfolio === undefined) {
      throw new Error('portfolio is not found')
    }
    const lease = acquireWriteOperation({
      portfolioId: portfolio.uuid,
      type: 'account-sync',
    })
    try {
      await analyzeAccountList({
        ...parameters,
        fiatCurrencyList: fiatCurrencies,
        apiEndpoint,
        datasourceApiEndpoint,
        proxyApiEndpoint,
        splTokenApiEndpoint,
        solanaRpcEndpoints,
        set,
      })
      await updateAssistantPendingCount({
        portfolioId: portfolio.uuid,
        readFromDatabase: parameters.readFromDatabase,
      })
      await set(updateIsRequiredCalculationAtom, parameters)
    } finally {
      lease.release()
    }
  },
)
